const DAYS = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];
const YN = [["yes", "Sí"], ["no", "No"]];
export const WEEK_DAYS = DAYS;

const POSITIONS = ["Portero", "Defensa central", "Lateral", "Mediocentro", "Interior o mediapunta", "Extremo", "Delantero", "Otra posición"];
const EQUIPMENT = ["Barra y discos", "Rack o jaula", "Mancuernas", "Kettlebells", "Bandas elásticas", "Máquinas de gimnasio", "Poleas",
  "Banco", "Cajón pliométrico", "Balón medicinal", "Conos y picas", "Escalera de agilidad", "Trineo", "Bicicleta estática",
  "Cinta de correr", "TRX o suspensión", "Sin material"];
const CAPACITIES = ["Velocidad", "Aceleración", "Fuerza", "Potencia y salto", "Resistencia", "Agilidad y cambios de dirección",
  "Movilidad", "Prevención de lesiones", "Composición corporal"];

const MEAL_FIELDS = [
  { k: "meal_times", label: "Horario habitual de desayuno, comida, merienda y cena", type: "mealtimes",
    help: "Si cambia según el día, activa «Mi horario cambia según el día»." },
  { k: "pre_eat", label: "¿Puedes comer antes de entrenar o competir?", type: "single", opts: ["Sí, sin problema", "Solo algo ligero", "No, me sienta mal", "Depende del horario"] },
  { k: "pre_eat_time", label: "Tiempo disponible entre tu última comida y entrenar o jugar", type: "single",
    opts: ["Menos de 30 min", "30-60 min", "1-2 h", "2-3 h", "Más de 3 h", "Variable"] },
];
const TRAVEL_FIELDS = [
  { k: "travels", label: "¿Sueles desplazarte para jugar?", type: "yesno" },
  { k: "packed_food", label: "¿Necesitas llevar comida preparada?", type: "yesno", show: (d) => d.travels === "yes" },
  { k: "travel_desc", label: "Duración habitual del viaje y dónde sueles comer", type: "textarea", max: 300, show: (d) => d.travels === "yes" },
  { k: "food_prefs", label: "Preferencias alimentarias", type: "textarea", max: 300, placeholder: "Vegetariano, alimentos que te gustan, cocina disponible…" },
];
export const MEALS = [["breakfast", "Desayuno"], ["lunch", "Comida"], ["snack", "Merienda"], ["dinner", "Cena"]];
export const fmtMealTimes = (v) => {
  const row = (x) => MEALS.map(([k, l]) => (x?.[k] ? `${l} ${x[k]}` : null)).filter(Boolean).join(" · ") || "—";
  if (!v?.varies) return row(v?.default);
  return DAYS.map((d) => `${d}: ${row(v.days?.[d] || v.default)}`).join("\n");
};
// Mini formulario de datos para la guía nutricional avanzada (Performance o superior)
export const NUTRI_INFO_STEPS = [
  { title: "Entrenamientos y partidos", fields: [
    { k: "team_days", label: "Días que entrenas con el equipo", type: "days" },
    { k: "team_sessions", label: "Hora y duración de cada entrenamiento", type: "sessions", daysFrom: "team_days" },
    { k: "match_days", label: "Día o días de partido", type: "days" },
    { k: "match_sessions", label: "Hora habitual y duración aproximada de los partidos", type: "sessions", daysFrom: "match_days", emptyText: "Marca primero los días de partido." },
  ] },
  { title: "Horarios de comida", fields: MEAL_FIELDS },
  { title: "Desplazamientos y preferencias", fields: TRAVEL_FIELDS },
  { title: "Alergias y alimentos que evitas", fields: [
    { k: "allergies", label: "Alergias o intolerancias", type: "textarea", max: 300, placeholder: "Escribe «ninguna» si no tienes" },
    { k: "foods_avoid", label: "Alimentos que no consumes", type: "textarea", max: 300 },
  ] },
];

// type: text | textarea | number | date | single | multi | yesno | days | sessions | mealtimes | repeat | videos
export const STEPS = [
  { b: "A", title: "Datos del futbolista", fields: [
    { k: "full_name", label: "Nombre completo", type: "text", req: true, known: "player_name" },
    { k: "age", label: "Edad", type: "number", min: 6, max: 60, unit: "años", req: true, known: "age" },
    { k: "birth_date", label: "Fecha de nacimiento (opcional)", type: "date" },
  ] },
  { b: "A", title: "Medidas y experiencia", fields: [
    { k: "weight_kg", label: "Peso", type: "number", min: 20, max: 160, unit: "kg", req: true, step: 0.1 },
    { k: "height_cm", label: "Estatura", type: "number", min: 100, max: 220, unit: "cm", req: true },
    { k: "years_playing", label: "Años jugando al fútbol", type: "number", min: 0, max: 40, unit: "años" },
  ] },
  { b: "A", title: "Tu equipo y posición", fields: [
    { k: "club", label: "Equipo o club actual", type: "text", known: "team" },
    { k: "category", label: "Categoría competitiva", type: "text", placeholder: "Ej. Juvenil División de Honor, Tercera RFEF…" },
    { k: "positions", label: "Posición o posiciones habituales", type: "multi", opts: POSITIONS, req: true, known: "positions" },
    { k: "dominant_foot", label: "Pie dominante", type: "single", opts: ["Derecho", "Izquierdo", "Ambos"], req: true },
  ] },
  { b: "B", title: "Entrenamientos con el equipo", fields: [
    { k: "team_days", label: "Días que entrenas con el equipo", type: "days" },
    { k: "team_sessions", label: "Horario y duración de cada sesión", type: "sessions", daysFrom: "team_days" },
    { k: "team_work", label: "Tipo de trabajo habitual con el equipo", type: "multi",
      opts: ["Táctico", "Posesiones", "Carrera continua", "Intervalos", "Velocidad", "Cambios de dirección", "Fuerza", "Prevención", "Otro"] },
    { k: "team_work_desc", label: "Describe el entrenamiento (opcional)", type: "textarea", max: 400 },
  ] },
  { b: "B", title: "Partidos", fields: [
    { k: "match_days", label: "Día o días de partido", type: "days" },
    { k: "match_sessions", label: "Hora habitual y duración aproximada de los partidos", type: "sessions", daysFrom: "match_days", emptyText: "Marca primero los días de partido." },
    { k: "match_minutes", label: "Minutos por partido", type: "single",
      opts: ["Habitualmente no juego", "Menos de 30", "30-60", "60-75", "75-90", "Variable"] },
    { k: "participation", label: "Participación habitual", type: "single",
      opts: ["Titular", "Suplente con minutos", "Suplente con pocos minutos", "No suelo jugar", "Variable"] },
    { k: "special_weeks", label: "Semanas con carga especial (opcional)", type: "textarea", max: 300, placeholder: "Torneos, doble partido, pretemporada…" },
  ] },
  { b: "B", title: "Descanso y disponibilidad", fields: [
    { k: "rest_days", label: "Días de descanso completo", type: "days" },
    { k: "individual_days", label: "Días disponibles para preparación física individual", type: "days" },
    { k: "individual_time", label: "Tiempo disponible por sesión individual", type: "single", opts: ["20-30 min", "30-45 min", "45-60 min", "Más de 60 min"] },
    { k: "unavailable_days", label: "Días que no puedes o no quieres entrenar", type: "days" },
  ] },
  { b: "C", title: "Experiencia en preparación física", fields: [
    { k: "gym_experience", label: "Tiempo entrenando fuerza en gimnasio", type: "single", req: true,
      opts: ["Nunca", "Menos de 3 meses", "3-12 meses", "1-2 años", "Más de 2 años"] },
    { k: "prior_plan", label: "¿Has seguido antes una planificación individual?", type: "yesno", req: true },
    { k: "prior_plan_desc", label: "¿Qué tipo de trabajo hacías y qué resultados obtuviste?", type: "textarea", max: 600, show: (d) => d.prior_plan === "yes" },
  ] },
  { b: "C", title: "Lo que haces ahora", fields: [
    { k: "current_methods", label: "Ejercicios o métodos que usas actualmente", type: "textarea", max: 500 },
    { k: "marks", label: "Marcas o referencias de rendimiento (opcional)", type: "textarea", max: 400, placeholder: "Ej. sentadilla 80 kg x 5, 30 m en 4,3 s…" },
    { k: "worked", label: "¿Qué te ha funcionado y qué no?", type: "textarea", max: 500 },
    { k: "avoid_exercises", label: "Ejercicios que no puedes hacer o prefieres evitar, y por qué", type: "textarea", max: 400 },
  ] },
  { b: "D", title: "Pruebas físicas", fields: [
    { k: "has_tests", label: "¿Tienes resultados recientes de pruebas físicas?", type: "yesno", req: true },
    { k: "tests", label: "Tus pruebas", type: "repeat", show: (d) => d.has_tests === "yes", addLabel: "Añadir prueba", fields: [
      { k: "kind", label: "Tipo", type: "single", opts: ["Sprint", "Salto", "Fuerza", "Agilidad", "Resistencia", "Otra"] },
      { k: "name", label: "Prueba", type: "text", placeholder: "Ej. 30 m lanzado, CMJ, Yo-Yo…" },
      { k: "value", label: "Resultado", type: "text", placeholder: "Ej. 4,21 s · 38 cm" },
      { k: "date", label: "Fecha", type: "date" },
      { k: "protocol", label: "Protocolo", type: "text", placeholder: "Cómo se hizo" },
      { k: "conditions", label: "Condiciones", type: "text", placeholder: "Césped, fotocélulas, cansado…" },
    ] },
    { k: "videos", label: "Vídeos (opcional)", type: "videos", help: "Pruebas, técnica de ejercicios… Máx. 150 MB por vídeo." },
  ] },
  { b: "D", title: "Qué quieres mejorar", fields: [
    { k: "capacities", label: "Capacidades más importantes a mejorar", type: "multi", opts: CAPACITIES },
    { k: "target_results", label: "Resultados concretos que quieres conseguir en este periodo", type: "textarea", max: 500 },
  ] },
  { b: "E", title: "Lesión o dolor actual", health: true, fields: [
    { k: "current_injury", label: "¿Tienes ahora alguna lesión, dolor o limitación?", type: "yesno", req: true },
    { k: "current_zone", label: "Zona", type: "text", show: (d) => d.current_injury === "yes" },
    { k: "current_duration", label: "¿Desde cuándo?", type: "text", show: (d) => d.current_injury === "yes" },
    { k: "current_aggravating", label: "Movimientos que la empeoran", type: "textarea", max: 400, show: (d) => d.current_injury === "yes" },
    { k: "current_limits", label: "¿Te limita?", type: "single", show: (d) => d.current_injury === "yes",
      opts: ["No limita", "Limita el entrenamiento", "Limita la competición", "Limita ambos"] },
  ] },
  { b: "E", title: "Lesiones anteriores", health: true, fields: [
    { k: "past_injuries", label: "¿Has tenido lesiones importantes?", type: "yesno", req: true },
    { k: "past_injuries_list", label: "Lesiones anteriores", type: "repeat", show: (d) => d.past_injuries === "yes", addLabel: "Añadir lesión", fields: [
      { k: "zone", label: "Zona", type: "text" },
      { k: "type", label: "Tipo de lesión", type: "text" },
      { k: "approx_date", label: "Fecha aproximada", type: "text", placeholder: "Ej. marzo 2025" },
      { k: "treatment", label: "Tratamiento", type: "text" },
      { k: "discharged", label: "¿Tienes el alta?", type: "single", opts: ["Sí", "No", "En proceso"] },
    ] },
  ] },
  { b: "E", title: "Indicaciones médicas y salud", health: true, fields: [
    { k: "medical_restrictions", label: "¿Tienes indicaciones o restricciones de un médico o fisioterapeuta?", type: "yesno", req: true },
    { k: "medical_restrictions_desc", label: "¿Cuáles?", type: "textarea", max: 400, show: (d) => d.medical_restrictions === "yes" },
    { k: "medical_conditions", label: "¿Tienes alguna condición médica relevante para hacer ejercicio?", type: "yesno", req: true,
      help: "Por ejemplo asma, problemas cardiacos, diabetes, epilepsia…" },
    { k: "medical_conditions_desc", label: "Descríbela", type: "textarea", max: 400, show: (d) => d.medical_conditions === "yes" },
    { k: "medication", label: "Medicación relevante (opcional y confidencial)", type: "textarea", max: 300 },
    { k: "other_health", label: "Cualquier otro aspecto de salud importante (opcional)", type: "textarea", max: 400 },
  ] },
  { b: "F", title: "Instalaciones y material", fields: [
    { k: "location", label: "Lugar principal de entrenamiento", type: "single",
      opts: ["Gimnasio comercial", "Gimnasio del club", "En casa", "Campo de fútbol", "Exterior o parque", "Combinación"] },
    { k: "equipment", label: "Material disponible", type: "multi", opts: EQUIPMENT },
    { k: "location_desc", label: "Describe dónde y con qué entrenas", type: "textarea", max: 400,
      show: (d) => ["En casa", "Campo de fútbol", "Exterior o parque", "Combinación"].includes(d.location) },
    { k: "cannot_use", label: "Equipamiento que no puedes usar (opcional)", type: "textarea", max: 300 },
  ] },
  { b: "G", title: "Disponibilidad y preferencias", fields: [
    { k: "preferred_time", label: "Horario preferido", type: "single", opts: ["Mañana", "Mediodía", "Tarde", "Noche", "Variable"] },
    { k: "busy_days", label: "Días con poco tiempo", type: "days" },
    { k: "session_priority", label: "¿Qué prefieres priorizar en las sesiones?", type: "textarea", max: 300 },
    { k: "likes_dislikes", label: "Ejercicios que te gustan o prefieres evitar", type: "textarea", max: 300 },
    { k: "consistency", label: "¿Qué te cuesta para ser constante?", type: "textarea", max: 300 },
  ] },
  { b: "H", title: "Sueño y estrés", fields: [
    { k: "sleep_hours", label: "Horas de sueño habituales", type: "single", opts: ["Menos de 6", "6-7", "7-8", "8-9", "Más de 9"] },
    { k: "sleep_quality", label: "Calidad del sueño", type: "single", opts: ["Mala", "Regular", "Buena", "Excelente"] },
    { k: "stress", label: "Nivel de estrés", type: "single", opts: ["Bajo", "Medio", "Alto"] },
    { k: "daily_activity", label: "Actividad diaria fuera del fútbol", type: "textarea", max: 300, placeholder: "Estudias, trabajas de pie, vas andando…" },
  ] },
  { b: "H", title: "Recuperación", fields: [
    { k: "next_day", label: "¿Cómo te encuentras al día siguiente de entrenar o competir?", type: "textarea", max: 300 },
    { k: "fatigue_moments", label: "Momentos de más fatiga", type: "textarea", max: 300 },
    { k: "recovery", label: "Estrategias de recuperación que usas", type: "textarea", max: 300 },
  ] },
  { b: "I", title: "Nutrición", fields: [
    { k: "allergies", label: "Alergias o intolerancias", type: "textarea", max: 300 },
    { k: "foods_avoid", label: "Alimentos que no consumes", type: "textarea", max: 300 },
    { k: "meals_per_day", label: "Comidas al día", type: "single", opts: ["2", "3", "4", "5", "6 o más"] },
    { k: "eating_out", label: "¿Con qué frecuencia comes fuera de casa?", type: "single", opts: ["Casi nunca", "1-2 veces/semana", "3-5 veces/semana", "Casi a diario"] },
  ] },
  { b: "I", title: "Horarios de comida", fields: MEAL_FIELDS },
  { b: "I", title: "Desplazamientos y preferencias", fields: TRAVEL_FIELDS },
  { b: "I", title: "Hábitos y registro", fields: [
    { k: "training_eating", label: "Dificultades para comer bien alrededor de los entrenamientos (opcional)", type: "textarea", max: 300 },
    { k: "digestive", label: "Problemas digestivos relevantes (opcional)", type: "textarea", max: 300 },
    { k: "has_scale", label: "¿Tienes báscula de cocina?", type: "yesno" },
    { k: "has_app", label: "¿Usas alguna app para registrar lo que comes?", type: "yesno" },
    { k: "willing_log", label: "¿Registrarías tu alimentación si fuera necesario?", type: "single", opts: ["Sí", "Solo si es necesario", "Prefiero no"] },
  ] },
  { b: "J", title: "Compromiso y objetivos", summary: true, fields: [
    { k: "main_goal", label: "Tu objetivo principal", type: "textarea", max: 300, showIfUnknown: "goals" },
    { k: "obstacle", label: "Tu principal obstáculo", type: "textarea", max: 250, showIfUnknown: "obstacle" },
    { k: "key_dates", label: "Fechas importantes en este periodo", type: "textarea", max: 300, placeholder: "Pruebas, inicio de temporada, torneos…" },
    { k: "first_change", label: "¿Qué cambio quieres notar primero en tu rendimiento?", type: "textarea", max: 300 },
    { k: "anything_else", label: "¿Algo más que deba saber como entrenador?", type: "textarea", max: 600 },
  ] },
];

export const BLOCK_NAMES = {
  A: "Datos del futbolista", B: "Calendario y carga", C: "Experiencia", D: "Valoración y pruebas", E: "Lesiones y seguridad",
  F: "Instalaciones y material", G: "Disponibilidad", H: "Recuperación", I: "Nutrición", J: "Compromiso y objetivos",
};

export const isVisible = (f, data, known) =>
  (!f.show || f.show(data)) && (!f.showIfUnknown || !known?.[f.showIfUnknown] || (Array.isArray(known[f.showIfUnknown]) && !known[f.showIfUnknown].length));

const filled = (v) => v !== undefined && v !== null && v !== "" && !(Array.isArray(v) && !v.length);

export const stepValid = (step, data, known) =>
  step.fields.every((f) => !f.req || !isVisible(f, data, known) || filled(data[f.k]) || (f.known && filled(known?.[f.known]) && data[f.k] === undefined));

export const YESNO = YN;
